const wordBreak = `
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
`;

export const mixins = {
  wordBreak
};
